import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SessionService } from '../../services/session.service';
import { PlatformApiService } from 'src/app/services/platform-api.service';
import { OidcFactory, AuthenticationType } from 'src/app/services/oidc.factory';
import { SentryError } from '@sentry/utils';
import { LoggerService } from 'src/app/services/logger.service';
import { environment } from 'src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { OidcConnectWiseService } from 'src/app/services/oidc.service';

@Component({
  selector: 'app-login-manager',
  template: `
    <app-login *ngIf="currentState == 'LOGIN'" (stateChange)="onStateChange($event)" [timeout]="sessionTimeout" [invalidSso]="invalidSso" [ssoLogout]="ssoLogout"></app-login>
    <app-login-verifymfa *ngIf="currentState == 'MFAREQUIRED' || currentState == 'SETUPTOTPMFA'" (stateChange)="onStateChange($event)" [cognitoUser]="cognitoUser" [totpSecretCode]="totpSecretCode" [mfaSetup]="currentState == 'SETUPTOTPMFA'"></app-login-verifymfa>
    <cw-ci-sso-match *ngIf="currentState == 'SSOMATCH'" (stateChange)="onStateChange($event)" [idToken]="idToken"></cw-ci-sso-match>
    <app-new-password *ngIf="currentState == 'NEWPASSWORD'" (stateChange)="onStateChange($event)" [email]="username" [existingPassword]="existingPassword"></app-new-password>
    <app-registration-confirm *ngIf="currentState == 'REGISTRATIONCONFIRM'" (stateChange)="onStateChange($event)" [email]="username" [confirmationCode]="confirmationCode"></app-registration-confirm>
    <app-forgot-password *ngIf="currentState == 'FORGOTPASSWORD'" (stateChange)="onStateChange($event)"></app-forgot-password>
    <app-forgot-password-confirm *ngIf="currentState == 'FORGOTPASSWORDCONFIRM'" (stateChange)="onStateChange($event)" [email]="username" [confirmationCode]="confirmationCode"></app-forgot-password-confirm>
  `,
  styleUrls: ['./auth.layout.scss']
})
export class AuthManagerComponent implements OnInit {
  // Valid States:
  // LOGIN
  // LOGINSUCCESS
  // FORGOTPASSWORD
  // FORGOTPASSWORDCONFIRM
  currentState;
  username;
  planId;
  referralCode;
  confirmationCode;
  partnerKey;
  existingPassword;
  cognitoUser;
  totpSecretCode;
  sessionTimeout = false;
  ssoLogout = false;
  invalidSso = false;
  idToken = undefined;
  linkAccountCallback;

  constructor(private _oidcCwService: OidcConnectWiseService, private _logger: LoggerService, private _router: Router, private _activatedRoute: ActivatedRoute, private _oidcFactory: OidcFactory, private _sessionService: SessionService, private _platformApi: PlatformApiService,private dialogRef: MatDialog) { }

  ngOnInit() {
    console.log("AuthManagerComponent:ngOnInit()");
    this._activatedRoute.queryParams.subscribe(params => {

      if (params.redirectUrl) {
        this._sessionService.setLoginRedirect(params.redirectUrl);
      }

      if (this._activatedRoute.routeConfig.path == 'register') {
        window.open(environment.trialRegistrationUrl);
      } else if (this._activatedRoute.routeConfig.path == 'confirm') {
        if (params.email) {
          this.username = params.email;
        }
        if (params.confirmationCode) {
          this.confirmationCode = params.confirmationCode;
        }
        this.currentState = 'REGISTRATIONCONFIRM';
      } else if (this._activatedRoute.routeConfig.path == 'forgotPassword') {
        if (params.email) {
          this.username = params.email;
        }
        if (params.confirmationCode) {
          this.confirmationCode = params.confirmationCode;
        }
        this.currentState = 'FORGOTPASSWORDCONFIRM';
      }else if (this._activatedRoute.routeConfig.path == 'logout') {
        this._sessionService.logout();
        this.dialogRef.closeAll();
        let qp = {};
        if (params.timeout != undefined) {
          qp = { timeout: true };
        } else if (params.ssoLogout != undefined) {
          qp = { ssoLogout: true };
        }
        qp['autoSso'] = false;
        this._router.navigate(['/public/login'], { queryParams: qp });
      } else if (this._activatedRoute.routeConfig.path == 'ssoLogin' && params.ssoIdToken) {
        this._sessionService.setAuthenticationType(AuthenticationType.SSOJWT, {idToken:params.ssoIdToken});
        this._platformApi.getCredentials().subscribe(
          creds => {
            this._sessionService.setApiCredentials(creds);
            this.onStateChange({state:'LOGINSUCCESS'});
          }, err => {
            this._logger.log('Error in SSO authentication via direct token', {error: err});
            this._sessionService.logout();
            this.invalidSso = true;
            this.currentState='LOGIN';
          }
        )
      } else if (this._activatedRoute.routeConfig.path == 'ssoLogin') {
        const oidcService = this._oidcFactory.getOidcService(AuthenticationType.SSOJWT);
        if (oidcService.setSigningState(window.location.href) != undefined) {
          oidcService.getManager().signinRedirectCallback().then(user => {
            this.handleSsoRedirect(user);
          }).catch(err => {
            this.currentState = 'LOGIN'
          })
        } else {
          oidcService.getManager().signinRedirect();
        }
      } else {
        this.sessionTimeout = params.timeout != undefined;
        this.ssoLogout = params.ssoLogout != undefined

        if (params.autoSso == undefined || !params.autoSso) {
          console.log("Attempting silent SSO");
          this._oidcCwService.getManager().signinSilent().then(user => {
            this.handleSsoRedirect(user);
          }).catch(err => {
            this.currentState = 'LOGIN';
          });
        } else {
          console.log("Skipping silent SSO");
          this.currentState='LOGIN';
        }
      }
    });
  }

  handleSsoRedirect(user) {
    this._platformApi.getCredentials().subscribe(
      creds => {
        this._sessionService.setApiCredentials(creds);
        this.onStateChange({state:'LOGINSUCCESS'});
      }, err => {
        if (err.status == 403) {
          this._logger.log('Attempting to match SSO via redirect');
          this.idToken = user.id_token;
          this.currentState = 'SSOMATCH';
        } else {
          this._logger.log('Error in SSO authentication via redirect', {error: err});
          this._sessionService.logout();
          this.invalidSso = true;
          this.currentState='LOGIN';
          throw err;
        }
      }
    )
  }

  onStateChange(event) {
    console.log(event);
    switch(event.state) {
      case 'LOGINSUCCESS':
        if(this.linkAccountCallback) {
          this.linkAccountCallback();
        } else {
          this._router.navigate(['/secured']);
          this.currentState = event.state;
        }
        break;
      case 'FORGOTPASSWORDCONFIRM':
        this.username = event.username;
        this.currentState = event.state;
        break;
      case 'REGISTRATIONCONFIRM':
        this.username = event.username;
        this.currentState = event.state;
        break;
      case 'NEWPASSWORD':
        this.username = event.username;
        this.existingPassword = event.existingPassword;
        this.currentState = event.state;
        break;
      case 'MFAREQUIRED':
      case 'SETUPTOTPMFA':
        this.cognitoUser = event.cognitoUser;
        this.totpSecretCode = event.secretCode;
        this.currentState = event.state;
        this.linkAccountCallback = event.linkAccountCallback;
        break;
      case 'CREATECANCEL':
        this.currentState = 'LOGIN';
        break;
      default:
        this.currentState = event.state;
        break;
    }
  }
}
